import React from 'react';
import Logo from './Logo';
import Auth from './Auth';
import {Link} from 'react-router-dom';
import { useSelector } from 'react-redux';

import './Header.css';

const Header = props => {
  const planNovi = useSelector(state => state.planNovi || 0);
  const planNeprocitani = useSelector(state => state.planNeprocitani || 0);

  return (
    <header className="header">
      <div className="header-left">
        <button className="hamburger" onClick={props.onMenuToggle} aria-label="Meni">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <Link to="/pocetna"><p className="tpservis_header">TMS</p></Link>
        {planNovi > 0 && (
          <span className="plan-novi-badge" title="Novi tiketi">{planNovi > 99 ? '99+' : planNovi}</span>
        )}
        {/* Odvojen od broja tiketa: ovaj kaze na koliko zadataka ceka
            nepročitan komentar. Dva razlicita podatka, pa i dva broja. */}
        {planNeprocitani > 0 && (
          <span className="plan-unread-badge" title="Zadaci sa nepročitanim komentarom">
            <i className="pi pi-comment" />{planNeprocitani > 99 ? '99+' : planNeprocitani}
          </span>
        )}
      </div>
      <Logo/>
      <div className="header-right">
        <Auth logout={props.logout} logged={props.token} user={props.user}/>
      </div>
    </header>
  );
};

export default Header;
